module.exports = __webpack_public_path__ + "media/src/images/logo-iversity-82d4b00d1df119775ae71aa359a17b1f.png";